import { useState } from 'react';
import { Accordion, Table, Title, Select } from '@mantine/core';
import { ILocation } from '../../../libraries/location';
import { useSelector } from 'react-redux';
import { AppState } from '../../client-redux/reducers';
import { Language } from '../../languages/languageHandler';
import { IconX } from '@tabler/icons-react';
import './styles.scss';

type LocationTableProps = {
  title: string;
  locations: ILocation[];
  currentEntid: number;
  editable?: boolean;
  value: number[];
  onChange: (shops: number[]) => void;
};

const LocationTable = ({ title, locations, currentEntid, editable, value, onChange }: LocationTableProps) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);
  const [selected, setSelected] = useState<string | null>(null);

  const handleAdd = (sid: string | null) => {
    if (!sid) return;
    const sidNum = Number(sid);
    if (!value.includes(sidNum)) {
      onChange([...value, sidNum]);
    }
    setSelected(null);
  };

  const handleRemove = (sid: number) => {
    onChange(value.filter(id => id !== sid));
  };

  const availableOptions = !locations
    ? []
    : locations
        .filter(loc => loc.entid === currentEntid && !value.includes(loc.sid))
        .map(loc => ({ value: String(loc.sid), label: loc.name || `SID ${loc.sid}` }));

  return (
    <Accordion variant="unstyled">
      <Title order={4}>{title}</Title>

      {editable && (
        <Select
          placeholder={lang.LOCATIONS_CHOOSE_LOCATION}
          value={selected}
          onChange={handleAdd}
          data={availableOptions}
          clearable
          disabled={availableOptions.length === 0 || !editable}
        />
      )}

      <Table className="locations-table">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>ID</Table.Th>
            <Table.Th>{lang.GLOBAL_NAME}</Table.Th>
            <Table.Th></Table.Th>
          </Table.Tr>
        </Table.Thead>

        <Table.Tbody>
          {value.length === 0 ? (
            <Table.Tr>
              <Table.Td colSpan={3}>{lang.GLOBAL_ALL}</Table.Td>
            </Table.Tr>
          ) : (
            value.map(sid => {
              const loc = locations.find(l => l.sid === sid && l.entid === currentEntid);
              if (!loc) return null;
              return (
                <Table.Tr key={`${loc.entid}-${loc.sid}`}>
                  <Table.Td>{loc.sid}</Table.Td>
                  <Table.Td>{loc.name}</Table.Td>
                  <Table.Td>{editable && <IconX stroke={2} onClick={() => handleRemove(loc.sid)} />}</Table.Td>
                </Table.Tr>
              );
            })
          )}
        </Table.Tbody>
      </Table>
    </Accordion>
  );
};

export default LocationTable;
